/**
 * Dark mode
 */

// Get toggle switch element
const toggleSwitch = document.querySelector(".dark-mode-switch");

// Toggle dark mode on click
toggleSwitch.addEventListener("click", switchTheme);

// Switch theme
function switchTheme() {
    // Get theme attribute
    const theme = document.documentElement.getAttribute("data-bs-theme");

    // Change theme
    if (theme === "dark") setThemeAttribute("light");
    else setThemeAttribute("dark");

    // Change icon
    changeIcon();

    // Add theme to local storage
    localStorage.setItem(
        "theme",
        document.documentElement.getAttribute("data-bs-theme")
    );
}

// Change icon
function changeIcon() {
    // Get i element inside toggleSwitch
    let toggleSwitchIcon = null;

    toggleSwitchIcon = toggleSwitch.querySelector("svg");

    // Change icon
    if (toggleSwitchIcon) {
        if (
            document.documentElement.getAttribute("data-bs-theme") === "light"
        ) {
            toggleSwitchIcon.classList.remove("fa-sun");
            toggleSwitchIcon.classList.add("fa-moon");
        } else {
            toggleSwitchIcon.classList.remove("fa-moon");
            toggleSwitchIcon.classList.add("fa-sun");
        }
    }
}

// Set theme attribute
function setThemeAttribute(mode) {
    document.documentElement.setAttribute("data-bs-theme", mode);
}

/*!
 * Color mode toggler for Bootstrap's docs (https://getbootstrap.com/)
 * Copyright 2011-2022 The Bootstrap Authors
 * Licensed under the Creative Commons Attribution 3.0 Unported License.
 */

(() => {
    "use strict";

    const storedTheme = localStorage.getItem("theme");

    const getPreferredTheme = () => {
        if (storedTheme) {
            return storedTheme;
        }

        return window.matchMedia("(prefers-color-scheme: dark)").matches
            ? "dark"
            : "light";
    };

    const setTheme = function (theme) {
        if (
            theme === "auto" &&
            window.matchMedia("(prefers-color-scheme: dark)").matches
        ) {
            document.documentElement.setAttribute("data-bs-theme", "dark");
        } else {
            document.documentElement.setAttribute("data-bs-theme", theme);
        }
    };

    setTheme(getPreferredTheme());

    changeIcon();

    window
        .matchMedia("(prefers-color-scheme: dark)")
        .addEventListener("change", () => {
            if (storedTheme !== "light" || storedTheme !== "dark") {
                setTheme(getPreferredTheme());
            }
        });
})();
